
import Vue from 'vue';
import Period from "../models/period";
import utils from "../services/utils";
import SchedulerService from "../services/scheduler.service"
import {eventBus} from "@/services/event-bus";
import EditPeriodForm from "@/components/EditPeriodForm.vue";
import MaterialCard from "../views/base/MaterialCard.vue";

export default Vue.extend({
  components: {
    addPeriodForm: EditPeriodForm,
    baseMaterialCard: MaterialCard,
  },
  data() {
    return {
      headers: [
        {
          text: this.$t('dateFrom'),
          value: 'dateFrom',
        },
        {
          text: this.$t('dateTo'),
          value: 'dateTo',
        },
        {
          text: this.$t('statistics'),
          value: 'statistics',
        },
        {
          text: this.$t('actions'),
          value: 'patients',
        },
      ],
      actions: [
        {
          color: 'info',
          icon: 'mdi-account',
          action: (item: any) => {
            this.$data.selectedPeriod = item;
            this.$router.push(`/periods/${item.id}`);
          }
        },
        {
          color: 'success',
          icon: 'mdi-pencil',
          action: (item: any) => {
            this.$data.period = item;
            this.$data.editPeriodDialog = true;
          }
        },
        {
          color: 'error',
          icon: 'mdi-close',
          action: (item: any) => {
            this.$data.loading = true;
            SchedulerService.deletePeriod(item.id).then(b => {
              if (b) {
                const idx = this.$data.elements.findIndex((el: any) => el.id == item.id);
                if (idx > -1) {
                  this.$data.elements.splice(idx, 1);
                }
              }
              this.$data.loading = false;
            }).catch(e => eventBus.$emit('error', e.message))
          }
        },
      ],
      elements: [] as Period[],
      loading: false,
      period: {} as any,
      editPeriodDialog: false,
      selectedPeriod: {} as any,
    }
  },
  methods: {
    getPatientsAsString(item: Period) {
      if (utils.isNull(item.patients)) {
        return 'Brak';
      }
      return item!.patients!.map(value => `${value.name} ${value.surname}`).join(', ');
    },
    onClickRow(item: any) {
      // this.$router.push({path: `/calendar/${item.type}/${item.id}`});
    },
    loadItems() {
      this.loading = true;
      SchedulerService.getPeriods().catch(e => eventBus.$emit('error', e.message)).then(this.onLoadItems)
    },
    onLoadItems(i: any) {
      this.elements = i.map((e: any) => new Period(e));
      this.loading = false;
    },
    hideForm() {
      this.editPeriodDialog = false;
      this.period = new Period({});
    },
    savePeriod(i: any) {
      let promise: any = {};
      if (i.id != null) {
        promise = SchedulerService.updatePeriod(i)
      } else {
        promise = SchedulerService.addPeriod(i)
            .then((p: any) => this.elements.push(new Period({id: p, dateFrom: i.dateFrom, dateTo: i.dateTo})));
      }
      promise
          .then(() => this.hideForm())
          .catch((e: any) => eventBus.$emit('error', e.message));
    },
    newPeriod() {
      this.period = new Period({});
      this.editPeriodDialog = true
    },
  },
  mounted(): void {
    this.loadItems();
    eventBus.$on("update-period", this.loadItems)
    eventBus.$on("update-activities", this.loadItems)
  },
  errorCaptured(err: Error, vm: Vue, info: string): boolean | void {
    eventBus.$emit('error', err.message);
  }
});
